// Simple event emitter for auth events
let logoutHandler = null;
let onLogoutComplete = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

export const setLogoutCompleteCallback = (callback) => {
  onLogoutComplete = callback;
};

export const triggerLogout = () => {
  if (logoutHandler) {
    logoutHandler();
    // Call completion callback if set
    if (onLogoutComplete) {
      onLogoutComplete();
    }
  }
};

